import { addHours, format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import Chip from '../common/chip'
import { Payment } from '../../types'
import AccountIcon from '../../assets/icons/account-icon.svg'
import CalendarIcon from '../../assets/icons/calendar-icon.svg'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon.svg'

export const PaymentCompletedListItem = ({ paymentData, handleOpenPaymentDetailsModal }: { paymentData: Partial<Payment>; handleOpenPaymentDetailsModal: (paymentData: Partial<Payment>) => void }) => {
  const { t } = useTranslation(['customer-details-management'])

  return (
    <div
      className="payment-list-item-data-container"
      onClick={() => {
        if (paymentData.status === 'reviewed' || paymentData.status === 'paid' || paymentData.status === 'validated') {
          handleOpenPaymentDetailsModal(paymentData)
        }
      }}
    >
      <div className="customer-company-table-column customer-company-table-width-10 display-none-xlg customer-company-table-width-70-md-down">
        <div className="customer-details-list-item-icon">
          <img
            src={CalendarIcon}
            alt="calendar-icon"
          />
        </div>
        <div className="customer-details-list-item-text">{format(addHours(new Date(String(paymentData?.createdAt)), 5), 'dd/MM/yyyy')}</div>
      </div>
      <div className="customer-company-table-column customer-company-table-width-45">
        <div className="customer-details-list-item-icon">
          <img
            src={AccountIcon}
            alt="account-icon"
          />
        </div>
        <div className="customer-details-list-item-text">{paymentData.customerData?.registeredFullName?.toUpperCase()}</div>
      </div>
      <div className="customer-company-table-column customer-company-table-width-45 novelties-container customer-company-table-width-30-md-down">
        <div className="novelty-container">
          <Chip
            status={String(paymentData.status)}
            label={
              paymentData.status === 'register-disperse-completed' || paymentData.status === 'processing'
                ? t('paymentStatus.processing')
                : paymentData.status === 'validated'
                ? t('paymentStatus.validated')
                : paymentData.status === 'reviewed'
                ? t('paymentStatus.reviewed')
                : t('paymentStatus.paid')
            }
          />
        </div>
        <div>
          <img
            src={ArrowRightIcon}
            alt="arrow-right-icon"
          />
        </div>
      </div>
    </div>
  )
}
